module.exports = __webpack_public_path__ + "static/media/cardimage.888b99d8.svg";